import type { ThemeOptions } from '@mui/material';
import macSepticLogo from '../../assets/brandings/macSeptic/macSepticLogo.png';
import macSepticNavbarLogo from '../../assets/brandings/macSeptic/macSepticNavbarLogo.png';

export const macSepticTheme: ThemeOptions = {
  assets: {
    logoURL: macSepticLogo,
    navbarLogoURL: macSepticNavbarLogo,
  },
  palette: {
    primary: { main: '#041141' },
    secondary: { main: '#71b1e3' },
    background: {
      default: '#f2f2f2',
      paper: '#fff',
    },
    rainfall: { main: '#da6833' },
    text: { primary: '#656565' },
    appBarBackground: {
      main: '#fff',
      light: '#fff',
      dark: '#fff',
      contrastText: '#fff',
    },
    appBarText: { main: '#041141' },
  },
};
